import { Component, OnInit, Input } from "@angular/core";
import { UICalendarEvent } from "src/app/core/calendar/ui-calendar-event.model";
import { AppService } from "src/app/core/app/app.service";
import { Router } from "@angular/router";
import { ProductType } from "src/app/core/product/enums/product-type.enum";
import { MDBModalRef } from "ng-uikit-pro-standard";

@Component({
  selector: "ll-pass-card",
  templateUrl: "./pass-card.component.html",
  styleUrls: ["./pass-card.component.scss"]
})
export class PassCardComponent implements OnInit {
  @Input() pass: UICalendarEvent;
  @Input() modalRef: MDBModalRef;
  constructor(private app: AppService, private router: Router) {}

  ngOnInit(): void {}

  get price(): number {
    return this.pass.price;
  }
  get max(): number {
    return this.pass.max ? this.pass.max : 1000;
  }
  get sold(): number {
    return this.pass.sold;
  }

  get name(): string {
    return this.pass.name;
  }

  get isAdmin(): string {
    return this.router.url.includes("admin") ? "/admin" : "";
  }
  edit(index: number) {
    this.modalRef.hide();
    if (this.pass.product.productType == ProductType.Bundle)
      this.app.isBundleForm = true;
    this.app.editProductBuilder(this.pass.product);
    this.router.navigateByUrl(
      `${this.isAdmin}/venue/passes/${
        index == 0 ? "pass-form" : "schedule-form"
      }`
    );
  }
}
